<template>
  <div>
    <!-- ナビバー -->
    <v-app-bar fixed color="white" height="100px">
      <v-toolbar-title>
        <v-img src="@/assets/img/aozora-logo.svg" title="" max-width="100px"></v-img>
      </v-toolbar-title>
    </v-app-bar>

    <!-- メイン -->
    <v-main >
      <!-- トップイメージ -->
      <v-parallax src="@/assets/img/4506344_m.jpg" height="1580">
        <v-row align="center" justify="center" class="black--text">
          <v-col class="text-center" cols="12">
            <h4 class="subheading mt-6">と う き た く す</h4>
            <p class="font-family-rogo text-kanji-logo">登記託</p>
          </v-col>
        </v-row>
      </v-parallax>
      <!-- メッセージ -->
      <v-snackbar v-model="snackbarMainMsg" :timeout=0  :top='true' :elevation='24' color="blue-grey lighten-5" class="mt-16 pt-10">
          <v-card color="transparent" flat class="v-card-msg">
            <v-card-text class="black--text text-sm-h6 text-lg-h4">
              <p class="d-flex align-center justify-center under">ただいまメンテナンス中です。</p>
            </v-card-text>
            <v-card-text class="black--text text-sm-h7 text-lg-h6">
              <v-row>
                <v-col cols="9" sm="9" md="9" lg="9" xl="9" class="d-flex align-center justify-center">
                  日頃より登記託をご利用いただき、誠にありがとうございます。
                  現在システムメンテナンスのため、こちらのページはご利用いただけません。
                  ご不便をお掛け致しますが、ご理解いただきますようお願い申し上げます。
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3" xl="3">
                  <v-img src="@/assets/img/ojigi.png" min-height="18vh"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-snackbar>
      <!-- 問い合わせ -->
      <!-- <v-snackbar v-model="snackbar" :timeout="snkTimeout"  :right='true' :elevation='24' color="grey lighten-3" :vertical='true' class="mb-16 pb-16">
          <v-card color="transparent" flat>
            <v-card-subtitle class="black--text">お電話でのお問い合わせはこちら<br/>営業時間 9:00 ～ 17:00 (定休日：土日祝日)</v-card-subtitle>
            <v-card-text class="black--text">
              <v-row >
                <v-col cols="2">
                  <v-icon class="info-box-keyframe black--text">mdi-phone-classic</v-icon>
                </v-col>
                <v-col cols="10" style="margin-bottom: 0px !important;">
                  <p class="text-h5">058-251-1233</p>
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="12">
                  <div style="info-box">

                  <v-img src="@/assets/img/tqsman-big.png" class="info-box-right"></v-img>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-snackbar> -->

    </v-main>
    <!-- フッター -->
    <!-- なし -->
  </div>
</template>

<script>

export default {
  data() {
    return {
      screenTitle: "",
      name: "homepagemainte",
      snackbar: true,
      snkTimeout: 0,
      snackbarMainMsg: true,
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
  },
};
</script>
<style scoped>
.font-family-rogo {
  position: relative;
  font-family: "HGP行書体", "Roboto", "ＭＳ Ｐ明朝", "MS PMincho", "STKaiti",
    "ヒラギノ明朝 Pro W3", "Hiragino Mincho Pro", serif !important;
  font-weight: bold;
  /*font-size: 3.3em;*/
}
.text-kanji-logo {
  font-size: 8rem !important;
  font-weight: 300;
  line-height: 8rem;
  letter-spacing: -0.015625em !important;

  animation-name: fadein;
  animation-duration: 18s;
  /* animation-iteration-count: infinite; */
}
@keyframes fadein {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.info-box {
  position: relative;
  height: auto;
  margin: 0 auto;
}
.info-box-right {
  position: absolute;
  top: 116%;
  right: -20px;
  transform: translateY(-80%);
  width: 100px;
  height: auto;
}
.info-box-keyframe {
  animation: loop 50s -25s linear infinite;
  animation-name: anim_s;
  transform: rotate(30deg);
  animation-duration: 5s;
}
@keyframes anim_s {
  50% {
      transform: rotate(-30deg);
  }
  100% {
      transform: rotate(30deg);
  }
}

.fade-enter-active, .fade-leave-active {
  will-change: opacity;
  transition: opacity 3025ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

.top-enter-active, .top-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.top-enter, .top-leave-to {
  transform: translateY(-100vh) translateY(0px);
}

.top-left-enter-active, .top-left-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.top-left-enter, .top-left-leave-to {
  transform: translateY(-100vh) translateX(-100vh);
}

.top-right-enter-active, .top-right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.top-right-enter, .top-right-leave-to {
  transform: translateY(-100vh) translateX(100vh);
}

.bottom-enter-active, .bottom-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.bottom-enter, .bottom-leave-to {
  transform: translateY(100vh) translateY(0px);
}

.bottom-left-enter-active, .bottom-left-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.bottom-left-enter, .bottom-left-leave-to {
  transform: translateY(100vh) translateX(-100vh);
}

.bottom-right-enter-active, .bottom-right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.bottom-right-enter, .bottom-right-leave-to {
  transform: translateY(100vh) translateX(100vh);
}

.left-enter-active, .left-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.left-enter, .left-leave-to {
  transform: translateX(-100vw) translateX(0px);
}

.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3025ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.v-card-msg {
  max-width: 100%;
  max-height: 20%;
}
.under {
  background: linear-gradient(transparent 70%, #ff99ab 70%);
}
@media screen and (max-width: 750px) {

  .text-kanji-logo {
    font-size: 6rem !important;
    font-weight: 300;
    line-height: 8rem;
    letter-spacing: -0.015625em !important;
  }
.v-card-msg {
  max-width: 60%;
  max-height: 60%;
  }
}
</style>
